import { useAppDispatch } from '../../../../../../redux/hooks'
import { setOpenStory } from '../../../../../../redux/reducers/messenger/chatSlice'
import { Message } from '../../../../../../types/api'
import DecryptedMessage from './DecryptedMessage'
import LinkifyText from '../../../../../../shared/LinkifyText'
import HlsPlayer from './HlsPlayer'

const isVideoFile = (url?: string) => {
  if (!url) return false
  const ext = url.split('?')[0].split('.').pop()?.toLowerCase() || ''
  return ['mp4', 'webm', 'ogg', 'mov', 'm3u8'].includes(ext)
}

const StoryMessage = ({ message }: { message: Message }) => {
  const dispatch = useAppDispatch()
  const storyMeta = message.metadata?.story
  const expiredAt = storyMeta?.expirted_at || storyMeta?.expired_at
  const isExpired = expiredAt ? new Date(expiredAt) < new Date() : false
  const storyHashkey = storyMeta?.story_hashkey || ''
  const storyUser = storyMeta?.story_user
  const isVideo = message.message_type === 'video' || isVideoFile(message.file_url)

  const handleClick = () => {
    if (!isExpired && storyHashkey) {
      dispatch(setOpenStory(storyHashkey))
    }
  }

  if (isExpired) {
    return (
      <div className="story-message story-message--expired">
        <div className="story-message__expired-content">
          <div className="story-message__expired-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>
          <span className="story-message__expired-text">Story no longer available</span>
        </div>
      </div>
    )
  }

  return (
    <div className="story-message" onClick={handleClick}>
      <div className="story-message__preview">
        {message.file_url ? (
          <div className="story-message__media">
            {isVideo ? (
              <div className="story-message__video-wrapper">
                <HlsPlayer message={message} />
              </div>
            ) : (
              <img src={message.file_url} alt="Shared story" className="story-message__image" />
            )}
            <div className="story-message__play-overlay">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </div>
        ) : (
          <div className="story-message__placeholder">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <path d="M21 15l-5-5L5 21" />
            </svg>
          </div>
        )}
      </div>
      <div className="story-message__info">
        {storyUser && (
          <div className="story-message__user">
            {storyUser.avatar && (
              <img src={storyUser.avatar} alt={storyUser.name} className="story-message__user-avatar" />
            )}
            <span className="story-message__user-name">{storyUser.name}</span>
          </div>
        )}
        <div className="story-message__label">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4l2 2" />
          </svg>
          <span>{isVideo ? 'Video Story' : 'Story'}</span>
        </div>
        {message.content && (
          <div className="story-message__caption">
            <DecryptedMessage message={message}>
              {(decryptedContent) => <LinkifyText text={decryptedContent} />}
            </DecryptedMessage>
          </div>
        )}
      </div>
    </div>
  )
}

export default StoryMessage
